// extracted by mini-css-extract-plugin
export default {"root":"FormSubtitle_root__T2xXa"};